import { __generator } from "tslib";
import React from 'react';
import { take, takeEvery, put, call, race, all } from 'redux-saga/effects';
import i18next from 'i18next';
import { Leave as LeaveIllustration } from '@wix/da-ds/pkg/Icons/Confirmations';
import { reduxModuleLoaded, updateNft, deleteNft } from './actions';
import { request } from '../../xhr';
import { isApiError } from '../../xhr/request';
import { putErrorNotification } from '../../utils/saga';
import { pushGlobalConfirmationModal, confirmYes, confirmNo, popModal, } from '../../Modals/redux/actionCreators';
function handleUpdateNft(action) {
    var _a, deviation, nft, nftData, deviationId, data, response, nftId, deleteData, deleteResponse;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action === null || action === void 0 ? void 0 : action.payload, deviation = _a.deviation, nft = _a.nft, nftData = _a.nftData;
                deviationId = deviation.deviationId;
                data = {
                    deviationid: "".concat(deviationId),
                    blockchain: nftData.blockchainName,
                    blockchain_identifier_primary: nftData.blockchainIdentifierPrimary,
                    blockchain_identifier_secondary: nftData.blockchainIdentifierSecondary,
                    link_to_marketplace: nftData.knownMarketplace,
                    custom_marketplace_url: nftData.unknownMarketplace
                        ? nftData.unknownMarketplaceLink
                        : undefined,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/deviation/nft/update',
                        data: data,
                    })];
            case 1:
                response = _b.sent();
                // Dismiss the NftLinkPopup
                return [4 /*yield*/, put(popModal())];
            case 2:
                // Dismiss the NftLinkPopup
                _b.sent();
                if (!(!response || isApiError(response) || !response.nft)) return [3 /*break*/, 4];
                return [4 /*yield*/, putErrorNotification(i18next.t('nft.linkPopup.error.update'))];
            case 3:
                _b.sent();
                return [2 /*return*/];
            case 4:
                if (!nft) return [3 /*break*/, 7];
                nftId = nft.nftId;
                if (!!(nft.blockchainName === nftData.blockchainName &&
                    nft.blockchainIdentifierPrimary === nftData.blockchainIdentifierPrimary &&
                    nft.blockchainIdentifierSecondary === nftData.blockchainIdentifierSecondary)) return [3 /*break*/, 7];
                deleteData = {
                    deviationid: "".concat(deviationId),
                    nftid: "".concat(nftId),
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/deviation/nft/delete',
                        data: deleteData,
                    })];
            case 5:
                deleteResponse = _b.sent();
                if (!(!deleteResponse || isApiError(deleteResponse) || !deleteResponse.success)) return [3 /*break*/, 7];
                return [4 /*yield*/, putErrorNotification(i18next.t('nft.linkPopup.error.delete'))];
            case 6:
                _b.sent();
                return [2 /*return*/];
            case 7:
                window.location.reload();
                return [2 /*return*/];
        }
    });
}
function handleDeleteNft(action) {
    var _a, deviation, nft, deviationId, nftId, no, data, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action === null || action === void 0 ? void 0 : action.payload, deviation = _a.deviation, nft = _a.nft;
                deviationId = deviation.deviationId;
                nftId = nft.nftId;
                return [4 /*yield*/, put(pushGlobalConfirmationModal({
                        titleTransKey: 'nft.linkPopup.deleteConfirmation.title',
                        textTransKey: 'nft.linkPopup.deleteConfirmation.text',
                        cancelBtnLabelTransKey: 'nft.linkPopup.deleteConfirmation.button.cancel',
                        confirmBtnLabelTransKey: 'nft.linkPopup.deleteConfirmation.button.delete',
                        icon: React.createElement(LeaveIllustration, null),
                        closeOnConfirmation: false,
                    }))];
            case 1:
                _b.sent();
                return [4 /*yield*/, race({
                        yes: take(confirmYes),
                        no: take(confirmNo),
                    })];
            case 2:
                no = (_b.sent()).no;
                // Dismiss the delete confirmation
                return [4 /*yield*/, put(popModal())];
            case 3:
                // Dismiss the delete confirmation
                _b.sent();
                if (no) {
                    return [2 /*return*/];
                }
                data = {
                    deviationid: "".concat(deviationId),
                    nftid: "".concat(nftId),
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/deviation/nft/delete',
                        data: data,
                    })];
            case 4:
                response = _b.sent();
                // Dismiss the NftLinkPopup
                return [4 /*yield*/, put(popModal())];
            case 5:
                // Dismiss the NftLinkPopup
                _b.sent();
                if (!(!response || isApiError(response) || !response.success)) return [3 /*break*/, 7];
                return [4 /*yield*/, putErrorNotification(i18next.t('nft.linkPopup.error.delete'))];
            case 6:
                _b.sent();
                return [2 /*return*/];
            case 7:
                window.location.reload();
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, take(reduxModuleLoaded)];
            case 1:
                _a.sent(); // wait for redux to load
                return [4 /*yield*/, all([
                        takeEvery(updateNft, handleUpdateNft),
                        takeEvery(deleteNft, handleDeleteNft),
                    ])];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map